import * as React from "react"
import { ChangeEvent } from "react" 
import TextInput from "../TextInput";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import * as _ from "lodash";
import IPatientCondition from "../../models/IPatientCondition";
import AppUtils from "../../utils/AppUtils";
import CustomSelect from "../CustomSelect";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import ModelFactory from "../../models/ModelFactory";
import * as $ from "jquery";

export interface ConditionItemEditorProps {
    item: IPatientCondition;
    onDataChange: (update: any) => any;
    showRelationshipDropdown: boolean;
    disableFields?: boolean;
}

export interface ConditionItemEditorState {
    validate: boolean;
}

class ConditionItemEditor extends React.Component<ConditionItemEditorProps, ConditionItemEditorState> {
    private conditionItemDOM: any;

    constructor(props: ConditionItemEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.conditionItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.conditionItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    generateRelationshipItems = (): IStaticDataValue[] => {
        let staticDataValues: IStaticDataValue[] = [];
        _.map(AppConstants.PatientRelationshipConstant, (relationship, key) => {
            if (relationship.internalValue !== AppConstants.PatientRelationshipConstant.SELF.internalValue) {
                let staticDataItem = ModelFactory.createNewStaticItem();
                staticDataItem.internalValue = key;
                staticDataItem.displayValue = relationship.displayValue;
                staticDataValues.push(staticDataItem)
            }
        })
        return staticDataValues;
    }

    generateYearItems = (year: number, startEnd: string): IStaticDataValue[] => {
        let staticDataValues: IStaticDataValue[] = [];
        let years = AppUtils.getYearsArrayFromPatientAge();
        if (startEnd === "START" && year !== null) years = years.filter(item => item <= year);
        else if (startEnd === "END" && year !== null) years = years.filter(item => item >= year);
        _.map(years, (year) => {
            let staticDataItem = ModelFactory.createNewStaticItem();
            staticDataItem.internalValue = year.toString();
            staticDataItem.displayValue = year.toString();
            staticDataValues.push(staticDataItem)
        })
        return staticDataValues;
    }

    onRelationshipDropdownChange = (value: string) => {
        let updatedItem = { ...this.props.item, relationship: value }
        this.props.onDataChange(updatedItem)
    }

    onOnsetAgeChange = (event: ChangeEvent<HTMLInputElement>) => {
        let onsetAge = isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        let updatedItem = { ...this.props.item, onSetAge: onsetAge };
        this.props.onDataChange(updatedItem);
        // let updatedItem = { ...this.props.item, onSetAge: event.target.value }
        // this.props.onDataChange(updatedItem)
    };

    onRelationshipChange = (event: ChangeEvent<HTMLSelectElement>) => {
        let updatedItem = { ...this.props.item, relationship: event.target.value }
        this.props.onDataChange(updatedItem)
    }

    onConditionStartMonthChange = (value: string) => {
        let updatedItem = { ...this.props.item, startMonth: value }
        this.props.onDataChange(updatedItem)
    }

    onConditionStartYearChange = (value: string) => {
        let updatedItem = { ...this.props.item, startYear: value }
        this.props.onDataChange(updatedItem)
    }


    onConditionTillDateChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, tillDate: event.target.checked }
        this.props.onDataChange(updatedItem)
    }

    onConditionEndMonthChange = (value: string) => {
        let updatedItem = { ...this.props.item, endMonth: value }
        this.props.onDataChange(updatedItem)
    }

    onConditionEndYearChange = (value: string) => {
        let updatedItem = { ...this.props.item, endYear: value }
        this.props.onDataChange(updatedItem)
    }

    onConditionCommentChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        let updatedItem = { ...this.props.item, comment: event.target.value }
        this.props.onDataChange(updatedItem)
    };

    render() {
        let myInstance = this;
        let fieldsDisabled = this.props.disableFields !== undefined ? this.props.disableFields : false;
        let onsetAge = this.props.item.onSetAge !== null ? this.props.item.onSetAge : "";
        let startMonth = this.props.item.startMonth !== null ? AppConstants.monthsConstant[this.props.item.startMonth] : null;
        let startYear = this.props.item.startYear !== null ? this.props.item.startYear.toString() : null;
        let endMonth = this.props.item.endMonth !== null ? AppConstants.monthsConstant[this.props.item.endMonth] : null;
        let endYear = this.props.item.endYear !== null ? this.props.item.endYear.toString() : null;
        let startYearItems = this.generateYearItems(!_.isEmpty(endYear) ? parseInt(endYear) : null, "START");
        let endYearItems = this.generateYearItems(!_.isEmpty(startYear) ? parseInt(startYear) : null, "END");
        let isTillDateChecked = this.props.item.tillDate !== null ? this.props.item.tillDate : false;
        let showRelationshipDropdown = this.props.showRelationshipDropdown !== undefined ? this.props.showRelationshipDropdown : false;
        let relationship = !_.isEmpty(this.props.item.relationship) ? AppConstants.PatientRelationshipConstant[this.props.item.relationship].displayValue : null;
        let relationshipValidationStatus = this.state.validate && _.isEmpty(this.props.item.relationship) ? "error" : "";
        return (
            <div  className="condition-item-editor" style={{ width: "120%" }} ref={(conditionItemDOM) => this.conditionItemDOM = conditionItemDOM}>
                {
                    showRelationshipDropdown &&
                    <div className={`condition-editor-relationship ${relationshipValidationStatus}`}>
                        <CustomSelect disabled={fieldsDisabled} dropdownValues={myInstance.generateRelationshipItems()} selectedValue={relationship} defaultValue={"Relationship"} updateDropdownValue={this.onRelationshipDropdownChange}/>
                    </div>
                }
                <div className="condition-editor-start">
                    <div className={"condition-editor-onset-age"}>
                        <TextInput disabled={fieldsDisabled} name={"condition-onset-age"} placeholder={AppPlaceholders.CONDITIONS_EDITVIEW_ONSET_AGE} onChange={this.onOnsetAgeChange} value={onsetAge} />
                    </div>
                    {
                        !showRelationshipDropdown &&
                        <div className={"condition-editor-start-month"}>
                            <CustomSelect disabled={fieldsDisabled} dropdownValues={AppUtils.generateMonthItems(AppConstants.monthsConstant, true)} selectedValue={startMonth} defaultValue={"Month"} updateDropdownValue={this.onConditionStartMonthChange}/>
                        </div>
                    }
                    <div className={"condition-editor-start-year"}>
                        <CustomSelect disabled={fieldsDisabled} dropdownValues={startYearItems} selectedValue={startYear} defaultValue={"Year"} updateDropdownValue={this.onConditionStartYearChange}/>
                    </div>
                </div>
                <div className="condition-editor-present">
                    <input type="checkbox" onChange={this.onConditionTillDateChange} checked={isTillDateChecked} disabled={fieldsDisabled} />
                    <span className={"checkbox-label"}>Present</span>
                </div>
                <div className="condition-editor-end">
                    {
                        !showRelationshipDropdown &&
                        <div className={`condition-editor-end-month`}>
                            <CustomSelect dropdownValues={AppUtils.generateMonthItems(AppConstants.monthsConstant, true)} selectedValue={endMonth} defaultValue={"Month"} updateDropdownValue={this.onConditionEndMonthChange} disabled={fieldsDisabled || isTillDateChecked}/>
                        </div>
                    }
                    <div className={"condition-editor-end-year"}>
                        <CustomSelect dropdownValues={endYearItems} selectedValue={endYear} defaultValue={"Year"} updateDropdownValue={this.onConditionEndYearChange} disabled={fieldsDisabled || isTillDateChecked}/>
                    </div>
                </div>
                <div className="condition-editor-attributes">
                    <TextInput disabled={fieldsDisabled} name="condition-attributes" value={this.props.item.comment || ""} placeholder={AppPlaceholders.CONDITIONS_EDITVIEW_ATTRIBUTES} onChange={this.onConditionCommentChange}/>
                </div>
            </div>
        )
    }
}

export default ConditionItemEditor;
